import React, { useState } from "react";
import styles from "./FaqPage.scss";
import SiteContainer from "components/homepage/SiteContainer";

const FAQ_ITEMS = [
    {
        question: "What is JazzWire?",
        answer: "JazzWire is an online jazz education platform created by acclaimed saxophonist and educator Jeff Antoniuk. It provides structured lessons, practice materials, play-alongs, courses, and learning paths for jazz musicians of all skill levels.",
    },
    {
        question: "How do I create a JazzWire account?",
        answer: (
            <>
                Click <a href="/sign-up">Join Now</a> on the JazzWire website and enter your name, email address, and payment information (if required). Once registration is complete, please allow up to two weeks for Jeff Antoniuk to create your Playing Evaluation and Practice Plan.
            </>
        ),
    },
    {
        question: "Does JazzWire offer a free trial?",
        answer: "Yes. JazzWire offers a 30-day free trial that allows new users to explore selected lessons and platform features before committing to a subscription. You'll have access to all of the lessons and conversations, but won't be able to contribute yourself if you're not a member.",
    },
    {
        question: "I forgot my password. How do I log in?",
        answer: (
            <>
                Click the <a href="/password-reset">Forgot Password</a> link on the login page and enter the email address associated with your account. You'll receive instructions to reset your password and regain access via email.
            </>
        ),
    },
    {
        question: "What types of lessons are available on JazzWire?",
        answer: "JazzWire offers lessons on improvisation, jazz theory, ear training, rhythm, harmony, repertoire, technique, and practice strategies. Content is organized into three weekly lessons, of various playing levels (Novice / Intermediate / and Advanced), working on Jazz tunes. These lessons are structured to help you learn songs and develop solo habits over top of them. There are smaller lessons and courses to help students progress efficiently and at their own pace. It's important to remember that posting yourself playing to receive feedback from faculty members and community members is as important as the lessons themselves! We want to hear you play!",
    },
    {
        question: "Can I access JazzWire on multiple devices?",
        answer: "Yes. You can access JazzWire from most modern computers, tablets, and smartphones using a web browser. Simply log in with your account credentials to continue learning from any supported device.",
    },
    {
        question: "How do I navigate the JazzWire content library?",
        answer: "After logging in, there are multiple places to look. Start with the search bar in the top right! You can filter by video / comment / post / and more! If you're having trouble narrowing it down, you can use the \"Resources\" tab in the bottom right to help find a specific lesson you're looking for.",
    },
    {
        question: "How does billing and subscription renewal work?",
        answer: "JazzWire subscriptions are billed monthly, renewing on the date you accept your first tuition (After Jeff completes your Playing Evaluation). Your subscription automatically renews unless canceled before the next billing cycle. You are committed to JazzWire for the first six-months, and then continue on a month-to-month subscription.",
    },
    {
        question: "Can I cancel my subscription at any time?",
        answer: "Yes. You can cancel your subscription by reaching out through the \"help\" portal, or via email to a team member on JazzWire. Access will continue until the end of your current billing period.",
    },
    {
        question: "What should I do if I can't access a lesson or course?",
        answer: "First, verify that you're logged into the correct account and that your subscription is active. If the issue persists, contact the JazzWire support team with details about the lesson and any error messages you are seeing.",
    },
];

function FaqItem({ index, question, answer }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={styles.faqItem}>
            <button
                type="button"
                className={styles.faqQuestion}
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
            >
                <span className={styles.faqNumber}>{index + 1}.</span>
                <span className={styles.faqQuestionText}>{question}</span>
                <span className={styles.faqToggle}>{isOpen ? "−" : "+"}</span>
            </button>
            {isOpen && (
                <div className={styles.faqAnswer}>
                    <p>{answer}</p>
                </div>
            )}
        </div>
    );
}

export default function FaqPage() {
    return (
        <SiteContainer minimal>
            <div className={`container ${styles.root}`}>
                <header className={styles.header}>
                    <h1>Customer Support FAQ</h1>
                    <p className={styles.intro}>
                        Here are 10 FAQ questions and answers that can help customers understand JazzWire while
                        covering login, billing, navigation, access, registration, and free trial topics.
                    </p>
                </header>
                <section className={styles.faqList}>
                    {FAQ_ITEMS.map((item, index) => (
                        <FaqItem
                            key={item.question}
                            index={index}
                            question={item.question}
                            answer={item.answer}
                        />
                    ))}
                </section>
            </div>
        </SiteContainer>
    );
}
